import { dynamicTranslations } from "@shared/utils/dynamicTranslation";
import { MEDICATION_BADGE_TONES, TMedicationBadgeStatus } from "../../../constants";
import { ReadingTag } from "./ReadingTag";

export const MedicationBadge = ({ status }: { status: TMedicationBadgeStatus }) => {
    const { t } = dynamicTranslations();
    const badge = MEDICATION_BADGE_TONES[status];

    return <ReadingTag label={t(badge.labelKey)} tone={badge.tone} />;
};

export default MedicationBadge;
